<template>
    <div>
        <Table ref="tableRef" style="margin-top: 20px;" :columns="columns" :data="tableData" border show-summary :summary-method="handleSummary"
            @on-sort-change="handleSort" :loading="loading" @on-column-width-resize="test">
            <template #footer>
                <div style="display: flex; justify-content: space-between;position:relative;z-index: 2;">
                    <Pages style="margin: 0 10px" :page="page" :func="handleGetData" :pArr="[31, 50]"></Pages>
                    <div></div>
                </div>
            </template>
        </Table>
    </div>
</template>

<script>
import Pages from '@/components/pages'

export default {
    components: {
        Pages,
        
    },
    props: {
        column: {
            type: Array,
            default: () => []
        },
        func: {
            type: Function,
            default: ()=>{}
        },
        searchForm: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            sortKey: '',
            page: {
                current: 1,
                size: 31
            },
            sortForm: {},
            tableData: [],
            loading:false,
            tableHeight: '400px',
            sum: {},
            columns: []
        }
    },
    watch:{
        'tableData':{
            handler(){
                if(!this.tableData.length){
                        this.tableHeight = '400px'
                    
                }else{
                    this.tableHeight = '24px'
                }
            },
            deep: true
        },
        column:{
            handler(){
                this.columns = this.column.map(i=>{
                    const func = i.render?i.render:(h,params)=>{
                                const v = params.row[i.key]||params.row[i.key]===0?params.row[i.key]: '-'
                                return <div>{v}</div>
                            }
                    return {
                        ...i,
                        render: i.render?i.render:!i.tooltip&&func,
                    }
                    
                })
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        test(e,_,column){
            column.width = e
        },
        handleGetData(current) {
                this.loading = true
            if (current) this.page.current = current
            else this.page.current = 1
            
            this.func({
                ...this.page,
                ...this.searchForm,
                ...this.sortForm
            }).then(({data})=>{
                this.tableData = data.pageData.records || []
                this.page.total = data.pageData.total
                this.sum = data.sum
                this.loading = false
            })
        },
        handleSummary({ columns }) {
            const res = {}
            const sums = {}
            this.column.forEach((column, index) => {
                const key = column.key
                if (!index) {
                    sums[key] = {
                        key,
                        value: '合计'
                    }
                    return
                }
                let v = 0
                if(Number(this.sum[key])){
                    v = Number(this.sum[key])
                }
                sums[key] = {
                    key,
                    value: v&&!column.notFixed?(column.needCalc ? ((v * 100).toFixed(2) + '%' || '-') : v.toFixed(2)) : (this.sum[key]?this.sum[key]+(column.unit||''):'-')
                }
            })

            return sums
        },
        handleSort({ column, key, order }) {
            this.sortKey = key

            this.column.forEach(el => {
                if (el.key == this.sortKey) {

                    this.sortForm.sortKeyId = el.index
                }
            });
            if (order == 'asc') {
                this.sortForm.sortDesc = false
            } else {
                this.sortForm.sortDesc = true
            }
            if (order == 'normal') {
                this.sortForm.sortKeyId = null
                this.sortForm.sortDesc = null

            }
            this.handleGetData()
        },
    }
}
</script>

<style lang="less" scoped>
/deep/.ivu-table td,
.ivu-table th {
    height: v-bind(tableHeight) !important;
}

/deep/.ivu-table {
    .ivu-table-tbody {
        .ivu-table-row:last-child {
            height: 31px;

            // td {
            //     vertical-align: top;
            //     height: 31px;
            // }
        }

    }
    td{
        position: relative;
        
    }
}
/deep/ .ivu-table-border{
    th, td{
        border-color: #fff;

    }
}
/deep/.ivu-table-wrapper{
    border-color: #fff;
}
/deep/.ivu-table-fixed{
    pointer-events: none;
    &>*{
        pointer-events: auto;
    }
}
</style>